export default __webpack_public_path__ + "static/media/xperience_rebrand_logo.a69fdbb9.svg";